import React, { LazyExoticComponent } from "react";
import PrivateRoute from "routes/PrivateRoute";
import PublicRoute from "routes/PublicRoute";

import { InnerLayout, MainLayout } from "components/layouts";
import { AuthUserCredentials } from "redux/reducers/authSlice";
import RoutePaths from "routes/RoutePaths";
import { Redirect } from "react-router-dom";

interface RouteProps {
  component: LazyExoticComponent<React.ComponentType<any>>;
  exact?: boolean;
  path: string;
  authUser?: AuthUserCredentials | null;
}

//Public Routes
const AuthRoute: React.FC<RouteProps> = ({
  component: Component,
  authUser,
  ...rest
}) => {
  if (!authUser) return <PublicRoute {...rest} component={Component} />;
  return <Redirect to={RoutePaths.root} />;
};
const ServiceAgreementRoute: React.FC<RouteProps> = ({
  component: Component,
  ...rest
}) => {
  return <PublicRoute {...rest} component={Component} layout={MainLayout} />;
};
const UserGuideRoute: React.FC<RouteProps> = ({
  component: Component,
  ...rest
}) => {
  return <PublicRoute {...rest} component={Component} layout={MainLayout} />;
};
const VerifyEmailRoute: React.FC<RouteProps> = ({
  component: Component,
  ...rest
}) => {
  return <PublicRoute {...rest} component={Component} />;
};

const PageNotFoundRoute: React.FC<RouteProps> = ({
  component: Component,
  ...rest
}) => {
  return <PublicRoute {...rest} component={Component} />;
};

const HomeRoute: React.FC<RouteProps> = ({ component: Component, ...rest }) => {
  return <PublicRoute {...rest} component={Component} layout={MainLayout} />;
};
const ExpertsCountryRoute: React.FC<RouteProps> = ({
  component: Component,
  ...rest
}) => {
  return <PublicRoute {...rest} component={Component} layout={MainLayout} />;
};

//Private Routes   StudentPurchasePointsRoute
const PasswordResetRoute: React.FC<RouteProps> = ({
  component: Component,
  ...rest
}) => {
  return <PublicRoute {...rest} component={Component} />;
};
const SelectedExpertProfileRoute: React.FC<RouteProps> = ({
  component: Component,
  ...rest
}) => {
  return <PublicRoute {...rest} component={Component} layout={MainLayout} />;
};
//Private Routes

const ExpertHomeRoute: React.FC<RouteProps> = ({
  component: Component,
  ...rest
}) => {
  return <PrivateRoute {...rest} component={Component} layout={MainLayout} />;
};

const ExpertProfileRoute: React.FC<RouteProps> = ({
  component: Component,
  ...rest
}) => {
  return <PrivateRoute {...rest} component={Component} layout={MainLayout} />;
};

const ExpertScheduleRoute: React.FC<RouteProps> = ({
  component: Component,
  ...rest
}) => {
  return <PrivateRoute {...rest} component={Component} layout={MainLayout} />;
};

const ExpertsRoute: React.FC<RouteProps> = ({
  component: Component,
  ...rest
}) => {
  return <PrivateRoute {...rest} component={Component} layout={MainLayout} />;
};

const ListOfReservationRoute: React.FC<RouteProps> = ({
  component: Component,
  ...rest
}) => {
  return <PrivateRoute {...rest} component={Component} layout={MainLayout} />;
};

const SettingsRoute: React.FC<RouteProps> = ({
  component: Component,
  ...rest
}) => {
  return <PrivateRoute {...rest} component={Component} layout={MainLayout} />;
};

const StudentLessonsRoute: React.FC<RouteProps> = ({
  component: Component,
  ...rest
}) => {
  return <PrivateRoute {...rest} component={Component} layout={MainLayout} />;
};
const StudentPurchasePointsRoute: React.FC<RouteProps> = ({
  component: Component,
  ...rest
}) => {
  return <PrivateRoute {...rest} component={Component} layout={MainLayout} />;
};

const ReservationRoute: React.FC<RouteProps> = ({
  component: Component,
  ...rest
}) => {
  return <PrivateRoute {...rest} component={Component} layout={MainLayout} />;
};

const IndividualLessonsRoute: React.FC<RouteProps> = ({
  component: Component,
  ...rest
}) => {
  return <PublicRoute {...rest} component={Component} layout={MainLayout} />;
};

const GroupLessonsRoute: React.FC<RouteProps> = ({
  component: Component,
  ...rest
}) => {
  return <PrivateRoute {...rest} component={Component} layout={MainLayout} />;
};

const LessonsRoute: React.FC<RouteProps> = ({
  component: Component,
  ...rest
}) => {
  return <PrivateRoute {...rest} component={Component} layout={MainLayout} />;
};

const LessonRoute: React.FC<RouteProps> = ({
  component: Component,
  ...rest
}) => {
  return <PrivateRoute {...rest} component={Component} layout={MainLayout} />;
};

const BankDetailsRoute: React.FC<RouteProps> = ({
  component: Component,
  ...rest
}) => {
  return <PrivateRoute {...rest} component={Component} layout={MainLayout} />;
};

const EditProfileRoute: React.FC<RouteProps> = ({
  component: Component,
  ...rest
}) => {
  return <PrivateRoute {...rest} component={Component} layout={MainLayout} />;
};
const StudentSelectReservationTimeSlotRoute: React.FC<RouteProps> = ({
  component: Component,
  ...rest
}) => {
  return <PrivateRoute {...rest} component={Component} layout={MainLayout} />;
};
const StudentSelectTimeSlotRoute: React.FC<RouteProps> = ({
  component: Component,
  ...rest
}) => {
  return <PrivateRoute {...rest} component={Component} layout={MainLayout} />;
};

const ExpertRevenueManagementRoute: React.FC<RouteProps> = ({
  component: Component,

  ...rest
}) => {
  return <PrivateRoute {...rest} component={Component} layout={MainLayout} />;
};
const ExpertViewEnrollmentsRoute: React.FC<RouteProps> = ({
  component: Component,

  ...rest
}) => {
  return <PrivateRoute {...rest} component={Component} layout={MainLayout} />;
};
const ExpertEnrollmentsLessonReportRoute: React.FC<RouteProps> = ({
  component: Component,

  ...rest
}) => {
  return <PrivateRoute {...rest} component={Component} layout={MainLayout} />;
};

const StaticPageRoute: React.FC<RouteProps> = ({
  component: Component,
  ...rest
}) => {
  return <PublicRoute {...rest} component={Component} layout={MainLayout} />;
};

const TeacherDetailsRoute: React.FC<RouteProps> = ({
  component: Component,

  ...rest
}) => {
  return <PrivateRoute {...rest} component={Component} layout={MainLayout} />;
};

const ContactFormRoute: React.FC<RouteProps> = ({
  component: Component,

  ...rest
}) => {
  return <PublicRoute {...rest} component={Component} layout={MainLayout} />;
};

const ContactFormSuccessRoute: React.FC<RouteProps> = ({
  component: Component,

  ...rest
}) => {
  return <PublicRoute {...rest} component={Component} layout={MainLayout} />;
};

export {
  HomeRoute,
  AuthRoute,
  VerifyEmailRoute,
  ExpertScheduleRoute,
  ExpertHomeRoute,
  ExpertProfileRoute,
  ExpertsCountryRoute,
  ExpertsRoute,
  PageNotFoundRoute,
  SettingsRoute,
  EditProfileRoute,
  SelectedExpertProfileRoute,
  ReservationRoute,
  StudentLessonsRoute,
  IndividualLessonsRoute,
  GroupLessonsRoute,
  LessonsRoute,
  LessonRoute,
  BankDetailsRoute,
  StudentSelectReservationTimeSlotRoute,
  StudentSelectTimeSlotRoute,
  ExpertRevenueManagementRoute,
  ExpertViewEnrollmentsRoute,
  ExpertEnrollmentsLessonReportRoute,
  StudentPurchasePointsRoute,
  PasswordResetRoute,
  ServiceAgreementRoute,
  UserGuideRoute,
  ListOfReservationRoute,
  StaticPageRoute,
  TeacherDetailsRoute,
  ContactFormRoute,
  ContactFormSuccessRoute
};
